<template>
  <div id="app">
    <TheHeader
      :class="$root.expanded ? 'mission-expanded' : null"
    />
    <main>
      <router-view/>
    </main>
    <TheFooter/>
  </div>
</template>

<script>
  import { sync } from 'vuex-router-sync';

  import store from '@/store';
  import router from '@/router';
  import TheHeader from '@/components/TheHeader';
  import TheFooter from '@/components/TheFooter';

  sync(store, router);

  export default {
    el: '#app',
    store,
    router,
    components: {
      TheFooter,
      TheHeader,
    },
    data() {
      return {
        expanded: false,
      };
    },
    created() {
      this.$store.dispatch('fetchSiteName');
    },
  };
</script>

<style lang="scss">
  :root {
    box-sizing: border-box;
    background-color: color(beige);
    color: color(slate);
    font-family: font-family(sans-serif);
    font-size: 62.5%;
    line-height: 1;
    letter-spacing: 0.025em;
    list-style-type: none;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  body {
    margin: 0;
    font-size: 1.6rem;

    @include breakpoint(tablet) {
      font-size: 2rem;
    }
  }

  main {
      overflow: hidden;
      min-height: 100vh;
  }

  button {
    display: block;
    border-style: none;
    padding: 0;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    text-align: inherit;
    cursor: pointer;
  }

  dd {
    margin-left: 0;
  }

  dl {
    margin-top: 0;
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: inherit;
  }

  img,
  svg {
    display: block;
    max-width: 100%;
  }

  li {
    display: block;
    list-style-type: inherit;
  }

  ol,
  ul {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;

    & + & {
      margin-top: spacing(base-gamma);
    }
  }

  @import "~plyr/src/sass/plyr";
</style>
